import { Box } from "@mui/material";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { links } from "utilities/links";
import { TiersForm } from "./TiersForm";
import { useStyles } from "./TiersForm.styles";

export const EditTiers = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const [tierSetData, setTierSetData] = useState({
    name: "",
    id: "",
  });

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: tierSetData.name,
      path: links.tierSet(tierSetData.id),
    },
  };
  const isTierDataLoaded = tierSetData.id !== "";

  return (
    <>
      {isTierDataLoaded && (
        <TopHeader
          title={message({ id: "editTiers" })}
          clearLink={links.tierSet(tierSetData.id)}
          breadcrumbs={breadcrumbs}
        />
      )}
      <Box className={classes.formContainer}>
        <TiersForm setTierSetData={setTierSetData} isEdit />
      </Box>
    </>
  );
};
